import React, { useState } from 'react';
import { Sidebar } from '../components/Sidebar';
import { Header } from '../components/Header';
import { ForecastList } from '../components/planning/ForecastList';
import { ClientList } from '../components/planning/ClientList';
import { ScheduleTimeline } from '../components/planning/ScheduleTimeline';
import { PlanningMap } from '../components/planning/PlanningMap';
import { RouteOptimizer } from '../components/planning/RouteOptimizer';
import { Calendar, List, Map, Route } from 'lucide-react';
type ViewMode = 'timeline' | 'list' | 'map' | 'optimizer';
export function Planning() {
  const [viewMode, setViewMode] = useState<ViewMode>('timeline');
  const [timePeriod, setTimePeriod] = useState('today');
  const [sidebarOpen, setSidebarOpen] = useState(true);
  return <div className="w-full min-h-screen bg-gray-50 flex" data-id="element-768">
      <Sidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} data-id="element-769" />
      <div className={`flex-1 transition-all duration-300 ${sidebarOpen ? 'ml-64' : 'ml-16'}`} data-id="element-770">
        <Header onTimePeriodChange={setTimePeriod} currentPeriod={timePeriod} data-id="element-771" />
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-772">
          {/* Page Header */}
          <div className="flex items-center justify-between mb-6" data-id="element-773">
            <div data-id="element-774">
              <h1 className="text-2xl font-bold text-gray-900" data-id="element-775">
                Planification & Prévisions
              </h1>
              <p className="text-sm text-gray-600 mt-1" data-id="element-776">
                Région de la Capitale-Nationale
              </p>
            </div>
            {/* View Mode Toggle */}
            <div className="flex items-center space-x-2 bg-white rounded-lg border border-gray-200 p-1" data-id="element-777">
              <button onClick={() => setViewMode('timeline')} className={`flex items-center space-x-2 px-3 py-2 rounded-md transition-colors ${viewMode === 'timeline' ? 'bg-blue-100 text-blue-700' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-778">
                <Calendar className="w-4 h-4" data-id="element-779" />
                <span className="text-sm font-medium" data-id="element-780">Chronologie</span>
              </button>
              <button onClick={() => setViewMode('list')} className={`flex items-center space-x-2 px-3 py-2 rounded-md transition-colors ${viewMode === 'list' ? 'bg-blue-100 text-blue-700' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-781">
                <List className="w-4 h-4" data-id="element-782" />
                <span className="text-sm font-medium" data-id="element-783">Liste</span>
              </button>
              <button onClick={() => setViewMode('map')} className={`flex items-center space-x-2 px-3 py-2 rounded-md transition-colors ${viewMode === 'map' ? 'bg-blue-100 text-blue-700' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-784">
                <Map className="w-4 h-4" data-id="element-785" />
                <span className="text-sm font-medium" data-id="element-786">Carte</span>
              </button>
              <button onClick={() => setViewMode('optimizer')} className={`flex items-center space-x-2 px-3 py-2 rounded-md transition-colors ${viewMode === 'optimizer' ? 'bg-blue-100 text-blue-700' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-787">
                <Route className="w-4 h-4" data-id="element-788" />
                <span className="text-sm font-medium" data-id="element-789">Optimisation</span>
              </button>
            </div>
          </div>
          {/* Content Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-790">
            {/* Left Column - Main Content */}
            <div className={viewMode === 'optimizer' ? 'lg:col-span-3' : 'lg:col-span-2'} data-id="element-791">
              {viewMode === 'timeline' && <ScheduleTimeline data-id="element-792" />}
              {viewMode === 'list' && <ForecastList data-id="element-793" />}
              {viewMode === 'map' && <PlanningMap data-id="element-794" />}
              {viewMode === 'optimizer' && <RouteOptimizer data-id="element-795" />}
            </div>
            {/* Right Column - Clients (hidden in optimizer view) */}
            {viewMode !== 'optimizer' && <div data-id="element-796">
                <ClientList data-id="element-797" />
              </div>}
          </div>
        </main>
      </div>
    </div>;
}